export default "__VITE_ASSET__BklmLPxb__"